import React, { memo } from "react";

import logger from "../../../../../utils/LoggerFrontend";
import CampaignCreateTeaserEditor from "../../Campaign__Create_TeaserEditor/Campaign__Create_TeaserEditor.jsx";
import { channelsByShortName } from "../../../../../data/app__channels";
import CampaignCreatePageSelectorClient from "../../PageSelectors/Campaign__Create_PageSelector__Client.jsx";
import CampaignCreatePerformanceEditor from "../../campaign-create-performance-editor/CampaignCreatePerformanceEditor.jsx";
import { PageHeader } from "../post-editor-facebook/page-header/PageHeader.jsx";
import useMediaAssets from "../hooks/useMediaAssets";
import TemplatePostPreview from "../../TemplatePost/TemplatePost__Preview/TemplatePostPreview";
import { useTranslation } from "react-i18next";

import * as SC from "./PostEditorInstagram.styled";
import * as LongSC from "./PostEditorLongInstagram.styled";

const PostEditorInstagram = ({
  orgaId,
  postData,
  channelData,
  updatePost,
  adsetId,
  editable,
  channel,
  updateChannelData,
  selectedCreativeIndexToEdit,
  setSelectedCreativeIndexToEdit,
  shouldRenderVerticalImage,
  campaignLanguage
}) => {
  logger.debug("PostEditorInstagram:render", "render:", {
    postData,
    channelData,
    updatePost,
    editable
  });

  const mediaAssets = useMediaAssets(postData);
  const templateSC = shouldRenderVerticalImage ? LongSC : SC;

  const minAspect = shouldRenderVerticalImage ? 0.5625 : channelsByShortName.instagram.minAspect;
  const maxAspect = shouldRenderVerticalImage ? 0.5625 : channelsByShortName.instagram.maxAspect;

  const templatePreviewSizes = {
    minHeight: templateSC.INSTAGRAM_IMAGE_SIZE_SPEC.minHeight,
    maxHeight: templateSC.INSTAGRAM_IMAGE_SIZE_SPEC.maxHeight,
    width: templateSC.INSTAGRAM_IMAGE_SIZE_SPEC.pictureWidth,
    minAspect: minAspect,
    maxAspect: maxAspect
  };

  const { t } = useTranslation();

  return (
    <SC.PostEditorInstagramWrapper isLong={shouldRenderVerticalImage}>
      <SC.InstagramLongWrapper>
        <templateSC.Bar>
          <templateSC.Progress />
        </templateSC.Bar>
        <templateSC.Header>
          <CampaignCreatePageSelectorClient
            updateChannelData={updateChannelData}
            pageId={channelData?.pageId}
            adsetId={adsetId}
          >
            <PageHeader
              pageLogo={channelData?.pageLogo}
              pageName={channelData?.pageName}
              pageId={channelData?.pageId}
              campaignLanguage={campaignLanguage}
              sponsoredMessageColor="#707070"
              sponsoredLogo
            />
          </CampaignCreatePageSelectorClient>
        </templateSC.Header>

        <TemplatePostPreview
          orgaId={orgaId}
          creatives={postData.creatives}
          creativeAssets={postData.creativeAssets}
          selectedMediaAssetIndexToEdit={selectedCreativeIndexToEdit}
          mediaAssets={mediaAssets}
          updatePost={updatePost}
          channel={channel}
          shouldRenderVerticalImage={shouldRenderVerticalImage}
          editable={editable}
          templatePreviewSizes={templatePreviewSizes}
          allowVideos={channelsByShortName.instagram.allowVideos}
          minAspect={minAspect}
          maxAspect={maxAspect}
        />

        {!shouldRenderVerticalImage && (
          <CampaignCreatePerformanceEditor
            creatives={postData.creatives}
            creativeAssets={postData.creativeAssets}
            editable={editable}
            mediaAssets={mediaAssets}
            channel={channel}
            updatePost={updatePost}
            padding="12px"
            selectedCreativeIndexToEdit={selectedCreativeIndexToEdit}
            setSelectedCreativeIndexToEdit={setSelectedCreativeIndexToEdit}
          />
        )}

        <templateSC.EditorWrapper>
          <CampaignCreateTeaserEditor
            channel="instagram"
            updatePost={updatePost}
            teaserText={postData.teaserText}
            teaserTextStyle={templateSC.teaserTextStyle}
            smallButtons
            minRows={4}
            editable={editable}
            isAutoGenerated={postData?.isAutoGenerated}
            autoGeneratedText={postData?.autoGeneratedText}
            isEdited={postData?.editedStates?.teaserText}
          />
        </templateSC.EditorWrapper>
        <templateSC.FooterWrapper>
          <templateSC.InstagramLearnMoreAnchor target="_blank" href={channelData.url}>
            <templateSC.InstagramLearnMoreArrow src="/images/arrow_up.png" alt="" />
            {t("Learn more", { lng: campaignLanguage })}
          </templateSC.InstagramLearnMoreAnchor>
        </templateSC.FooterWrapper>
      </SC.InstagramLongWrapper>
      {shouldRenderVerticalImage && (
        <CampaignCreatePerformanceEditor
          creatives={postData.creatives}
          creativeAssets={postData.creativeAssets}
          editable={editable}
          mediaAssets={mediaAssets}
          channel={channel}
          updatePost={updatePost}
          padding="12px"
          selectedCreativeIndexToEdit={selectedCreativeIndexToEdit}
          setSelectedCreativeIndexToEdit={setSelectedCreativeIndexToEdit}
        />
      )}
    </SC.PostEditorInstagramWrapper>
  );
};

export default memo(PostEditorInstagram);
